import Vue from "vue";
import Vuex from "vuex";
import login from "./modules/login";
import general from "./modules/general";
import preloader from "./modules/preloader";
import snackbar from "./modules/snackbar";
import userdetails from "./modules/user-details";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    general,
    preloader,
    snackbar,
    userdetails
  }
});



//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 